import type { ParameterData } from '@/core/types/library.type'

export const getParameterNamesSummary = (parameters: ParameterData[]): string | undefined => {
  const names = parameters.map(({ name }) => name).filter(Boolean)

  if (names.length === 0) {
    return undefined
  }

  if (names.length === 1) {
    return `Accepts ${names[0]}`
  }

  const leadingNames = names.slice(0, -1).join(', ')
  const lastName = names[names.length - 1]

  return `Accepts ${leadingNames} and ${lastName}`
}
